import "react";
import o from "./index148.mjs";
import "./index58.mjs";
import { useDefaultProps as r } from "./index552.mjs";
process.env.NODE_ENV !== "production" && (o.node, o.object.isRequired);
function i(e) {
  return r(e);
}
export {
  i as useDefaultProps
};
